import React from 'react';

export type ClickEvent = React.MouseEvent<HTMLElement>;
export type ClickHandler = (event: ClickEvent) => void;

// Every onClick handler passed to a HTML or MUI element should be wrapped in this function.
//  This will stop funny business, like the event propagating to parents.
//  If you're using Axle components, this will already have been done for you, so no need.
export const wrapOnClick = ((onClick?: ClickHandler): ClickHandler | undefined => {
    if (onClick === undefined) {
        return undefined;
    }
    return (event: ClickEvent) => {
        // Without this, the click event can propagate to parents, and cause duplicate actions.
        // Q: Why don't we call `event.preventDefault()` too?
        // A: Because it messes with radio buttons and checkboxes.
        event.stopPropagation();
        onClick(event);
    };
}) as ((onClick: ClickHandler) => ClickHandler) &
    ((onClick?: ClickHandler) => ClickHandler | undefined);
// The type assertion above lets Typescript know if the input wasn't undefined, the output won't be either.
// Copied from https://stackoverflow.com/a/65547718

export const dontLetClicksEscape = wrapOnClick(() => undefined);
